import { gql } from 'apollo-angular';

export const TIME_ENTRIES_SUM_QUERY = gql`
query TimeEntriesSumQuery(
  $ownerId: UUID
)
{
  timeEntriesSum: getTimeEntriesSum(
    filter: {
      ownerId: $ownerId
  })
}
`;

export interface TimeEntriesSumQueryResponse {
  timeEntriesSum: number;
  loading: boolean;
}


